<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-dark shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
          <div class="col px-0">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-7 text-center pt-lg">
                <p class="h1 text-white mt-4 mb-5">Levenshtein distance</p>
                <p class="lead text-white mt-4 mb-0">Levenshtein distance is a number that tells how different two strings are.
                  The higher the number, the more different the two strings are.
                  For example, the Levenshtein distance between “kitten” and “sitting” is 3 since, at a minimum, 3 edits are required to change one into the other. </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg mt--300">
      <div class="">
        <div class="container">
          <div class="row justify-content-center" shadow>
            <div class="col-lg-4">
              <input
                type="text"
                class="form-control"
                v-model="firstWord"
                id="firstWord"
                placeholder="First word"
                aria-label="firstWord"
              />
            </div>
            <div class="col-lg-4">
              <input
                type="text"
                class="form-control"
                v-model="secondWord"
                id="secondWord"
                placeholder="Second word"
                aria-label="secondWord"
              />
            </div>
            <div class="buttono">
              <base-button
                class="btn-3"
                type="primary"
                icon="ni ni-bag-17"
                @click="matchWords"
                >MATCH IT!</base-button
              >
            </div>
          </div>
          <div class="my-3">
            <h2 class="text-center my-5 py-5">
              <b>Your distance is: {{ levenResult }}</b>
            </h2>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Carousel from "./components/Carousel.vue";
const axios = require("axios");

export default {
  name: "home",
  components: { Carousel },
  data: function () {
    return {
      firstWord: null,
      secondWord: null,
      loading: false,
      levenResult: null,
    };
  },
  methods: {
    matchWords() {
      this.loading = true;
      let concatenation = this.firstWord + "-" + this.secondWord;
      axios
        .get(
          "https://owum2l5qvk.execute-api.us-east-1.amazonaws.com/dev/matcher?words=",
          {
            params: {
              words: concatenation,
            },
          }
        )
        .then((response) => {
          this.loading = false;
          this.levenResult = response.data.input.levenshtein_distance;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
